import React from "react";

const Banner = () => {
  const testimonials = [
    {
      id: 1,
      title: "Prenez Rendez-vous",
      description:
        "Profitez  <strong class=' font-bold '>d’un appel gratuit</strong> avec nos conseillers spécialisés et planifiez votre rendez-vous dès maintenant !",

      shape: "1",
    },
    {
      id: 2,
      title: "Consultez nos experts",
      description:
        "Bénéficiez <strong class=' font-bold'>d'une consultation 100% gratuite</strong> avec un expert dans nos locaux pour vérifier votre dossier et votre éligibilité.",
      shape: "2",
    },
    {
      id: 3,
      title: "Consultez un avocat",
      description:
        "Nous vous mettons en relation avec l’un de nos <strong class=' font-bold '>avocats spécialisés,</strong> à <strong class=' font-bold '>un tarif fixe défiant toute concurrence.</strong>",
      shape: "3",
    },
  ];

  return (
    <div
      className="how-does-wrapper"
      style={{
        backgroundImage: `url("/assets/img/theme/how-does-bg.jpg")`,
      }}
    >
      <div className="container mx-auto">
        <div className="title pb-5">
          <span className="title-border-img">
            <img src="/assets/img/theme/spliter-1.png" alt="" />
          </span>
          <h2>Comment ça marche ?</h2>
        </div>
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id}>
              <div className="tes-wrapper">
                <h3 className="whitespace-pre-wrap lg:whitespace-no-wrap">
                  {testimonial.title}
                </h3>
                <p
                  dangerouslySetInnerHTML={{ __html: testimonial.description }}
                />
                <div className="shape">
                  <img
                    src={`/assets/img/theme/${testimonial.id}.png`}
                    alt={testimonial.title}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Banner;
